import { NgModule, NO_ERRORS_SCHEMA }   from '@angular/core';
import { CommonModule }                 from '@angular/common';
import { NgxMaskModule }                from 'ngx-mask';

import { InfinityItemComponent }        from './infinity-item.component';
import { SafeHtmlPipe }                 from './safe-html.pipe';

@NgModule({
    imports: [
        CommonModule,
        NgxMaskModule.forRoot()
    ],
    declarations: [
        InfinityItemComponent,
        SafeHtmlPipe
    ],
    schemas: [ NO_ERRORS_SCHEMA ],
    exports: [ InfinityItemComponent ]
})
export class InfinityItemModule {}
